import React from 'react';

export const PrevFileSignature = ({item, error}) => {
    return (
        <div className="preview-info-line">
            <div
                className="preview-info-line-value"
                style={{
                    paddingBottom: '4px',
                    borderBottom: error ? '1px solid #FE7070' : '1px solid #9CA3AF',
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                {item?.value?.url ?
                    <img
                        alt="signatue"
                        src={item?.value?.url}
                        style={{maxHeight: '50px', maxWidth: '100%', objectFit: 'contain'}}
                    />
                    :
                    ''
                }
            </div>
        </div>
    );
};
